import Vue from 'vue';
import { Guard } from '../plugins/guards/guardWrapper';

export default {
  name: 'ConfigLoaderGuard',
  // Synchronous since the config needs to be available universally
  async appLoad() {
    try {
      await Vue.$config.refresh();
    } catch (error: any) {
      const message = `Unable to load app because config was not loaded correctly! Critical failure: ${error}`;
      Vue.$log.error(message);
      Vue.$log.error(error.stack);
      throw new Error(message);
    }
  },
} as Guard;
